import React from 'react';

export function AuditTimelineMarker() {
  return (
    <div className="relative flex w-5 justify-center max-md:h-14.5 max-md:w-4">
      <span className="relative z-10 mt-0.5 h-4 w-4 rounded-full border-4 border-blue-200 bg-white max-md:mt-px" />

      <span
        className="
          absolute
          top-4
          h-[calc(100%+8px)]
          w-[2px]
          bg-[#D9E2F3]
          max-md:top-3.25
          max-md:h-11.25
        "
      />
    </div>
  );
}
